import { all, call, put, takeLatest } from "redux-saga/effects";

import {
  getAccountInfoStart,
  getAccountInfoSuccess,
  getAccountInfoFailed,
} from "../redux/accountInfo";

import { getAccountInfoApi } from "core/http/service/accountInfo";

function* getWorkInformationWork() {
  try {
    const res = yield call(getAccountInfoApi);

    yield put({
      type: getAccountInfoSuccess.type,
      payload: res,
    });
  } catch (error: any) {
    yield put({
      type: getAccountInfoFailed.type,
    });
  }
}

function* watchAccountInfo() {
  yield takeLatest(getAccountInfoStart.type, getWorkInformationWork);
}

export default function* accountInfoSaga() {
  yield all([watchAccountInfo()]);
}
